/* eslint-disable consistent-return */
import { API_URL } from 'api/api';
import { ObjectToFormData } from './ObjectToFormData';

const downloadFile = async (formpostObject, filename, subURL) => {
  const myHeaders = new Headers();
  myHeaders.append('accept', 'application/json, text/plain, */*');
  const token = localStorage.getItem('token');
  myHeaders.append('authorization', `Bearer ${token}`);
  const formData = ObjectToFormData(formpostObject);
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: formData,
  };
  const res = await fetch(`${API_URL}/${subURL}`, requestOptions);
  if (!res.ok) {
    throw new Error(res.statusText);
  }
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export default downloadFile;
